import React, {useEffect, useState} from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {useNavigate, useParams} from "react-router-dom";
import {baseUrl, ipAddress, userLocation, userName} from "../Univ.js";
import "./IoTStyles.css";
function IoTGatewayForm() {
    const navigate = useNavigate();
    const {id} = useParams();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        gateway_id: "",
        gateway_name: "",
        ip_address: "",
        port: "",
        hospital_code: "",
        location: "",
        version: "",
        status: "OFFLINE"
    });
    useEffect(() => {
        if (id) {
            fetchGateway();
        }
    }, [id]);
    const fetchGateway = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                baseUrl +
                "iot-gateways/" +
                id +
                "/"
            );
            setFormData({
                ...formData,
                ...response.data
            });
        } catch (error) {
            console.log(error);
            Swal.fire(
                "Error",
                "Unable to load gateway.",
                "error"
            );
        } finally {
            setLoading(false);
        }
    };
    const inputHandler = (event) => {
        setFormData({
            ...formData,
            [event.target.name]:
            event.target.value
        });
    };
    const submitHandler = async (event) => {
        event.preventDefault();
        if (
            !formData.gateway_id ||
            !formData.gateway_name
        ) {
            Swal.fire(
                "Required",
                "Gateway ID and Gateway Name are required.",
                "warning"
            );
            return;
        }
        try {
            setLoading(true);
            const payload = {
                ...formData,
                addedby: userName,
                ip_add: ipAddress,
                location: userLocation
            };
            let response;
            if (id) {
                response = await axios.put(
                    baseUrl +
                    "iot-gateways/" +
                    id +
                    "/",
                    payload
                );
            } else {
                response = await axios.post(
                    baseUrl +
                    "iot-gateways/",
                    payload
                );
            }
            if (
                response.status === 200 ||
                response.status === 201
            ) {
                Swal.fire({
                    title: id
                        ? "Gateway Updated"
                        : "Gateway Registered",
                    icon: "success",
                    timer: 2000,
                    showConfirmButton: false
                });
                setTimeout(() => {
                    navigate(
                        "/iot-gateways/"
                    );
                }, 1500);
            }
        } catch (error) {
            console.log(error);
            Swal.fire(
                "Error",
                "Unable to save gateway.",
                "error"
            );
        } finally {
            setLoading(false);
        }
    };
    return (
        <section className="container mt-4">

            <div className="iot-page-header">

                <div>

                    <h3>

                        {id
                            ? "Edit IoT Gateway"
                            : "Register IoT Gateway"}

                    </h3>

                    <p>
                        Configure the hospital IoT gateway
                    </p>

                </div>

            </div>


            <div className="card shadow-sm">

                <div className="card-header">

                    <strong>
                        Gateway Configuration
                    </strong>

                </div>


                <div className="card-body">

                    <form onSubmit={submitHandler}>

                        <div className="row">

                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Gateway ID *
                                </label>

                                <input
                                    type="text"
                                    name="gateway_id"
                                    className="form-control"
                                    placeholder="GW-ICU-01"
                                    value={
                                        formData.gateway_id
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                    disabled={!!id}
                                />

                            </div>


                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Gateway Name *
                                </label>

                                <input
                                    type="text"
                                    name="gateway_name"
                                    className="form-control"
                                    placeholder="ICU IoT Gateway"
                                    value={
                                        formData.gateway_name
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                />

                            </div>

                        </div>


                        <div className="row">

                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    IP Address
                                </label>

                                <input
                                    type="text"
                                    name="ip_address"
                                    className="form-control"
                                    placeholder="192.168.1.10"
                                    value={
                                        formData.ip_address
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                />

                            </div>


                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Port
                                </label>

                                <input
                                    type="number"
                                    name="port"
                                    className="form-control"
                                    placeholder="8080"
                                    value={
                                        formData.port
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                />

                            </div>

                        </div>


                        <div className="row">

                            <div className="col-md-4 mb-3">

                                <label className="form-label">
                                    Hospital Code
                                </label>

                                <input
                                    type="text"
                                    name="hospital_code"
                                    className="form-control"
                                    value={
                                        formData.hospital_code
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                />

                            </div>


                            <div className="col-md-4 mb-3">

                                <label className="form-label">
                                    Location
                                </label>

                                <input
                                    type="text"
                                    name="location"
                                    className="form-control"
                                    placeholder="ICU"
                                    value={
                                        formData.location
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                />

                            </div>


                            <div className="col-md-4 mb-3">

                                <label className="form-label">
                                    Gateway Version
                                </label>

                                <input
                                    type="text"
                                    name="version"
                                    className="form-control"
                                    placeholder="1.0.0"
                                    value={
                                        formData.version
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                />

                            </div>

                        </div>


                        <div className="row">

                            <div className="col-md-6 mb-3">

                                <label className="form-label">
                                    Status
                                </label>

                                <select
                                    name="status"
                                    className="form-control"
                                    value={
                                        formData.status
                                    }
                                    onChange={
                                        inputHandler
                                    }
                                >

                                    <option value="ONLINE">
                                        Online
                                    </option>

                                    <option value="OFFLINE">
                                        Offline
                                    </option>

                                    <option value="MAINTENANCE">
                                        Maintenance
                                    </option>

                                </select>

                            </div>

                        </div>


                        <div className="text-center mt-3">

                            <button
                                type="button"
                                className="btn btn-secondary me-2"
                                onClick={() =>
                                    navigate(
                                        "/iot-gateways/"
                                    )
                                }
                            >
                                Cancel
                            </button>


                            <button
                                type="submit"
                                className="btn btn-success"
                                disabled={loading}
                            >
                                {loading
                                    ? "Saving..."
                                    : id
                                        ? "Update Gateway"
                                        : "Register Gateway"}
                            </button>

                        </div>

                    </form>

                </div>

            </div>

        </section>
    );
}
export default IoTGatewayForm;
